import Vue from "vue";
import i18n from "@/modules/i18n";

export default {
  state: {
    panier: {},
  },
  getters: {
    panier(state) {
      return state.panier;
    },
    quantiteLigne(state)   {
      return Object.keys(state.panier).length;
    },
  },
  mutations: {
    setPanier(state, panier) {
      // Hack pour obliger Vue à être réactif
      state.panier = {...panier}
      localStorage.setItem("panier", JSON.stringify(state.panier));
    },
  },
  actions: {
    /**
     * Met en place ou met à jour le panier pour l'utilisateur.
     * @param {Object} commit
     * @param {Object} getters
     * @returns {Promise} Panier de l'utilisateur.
     */
    async initPanier({ commit, getters }) {
      commit("setPanier", JSON.parse(localStorage.getItem("panier")) || {});
    },
    /**
     * Ajoute des articles au panier.
     * @param {Object} commit
     * @param {Object} getters
     * @param {Array} lignes
     */
    setOfferToPanier({ commit, getters }, { ligne = {} }) {
      if (!ligne) return;
      // Si la liste du produit est différente de celle du panier
      // On vide le panier
      if (
        Object.keys(getters.panier).length > 0 &&
        getters.panier[Object.keys(getters.panier)[0]].liste_id !== ligne.liste_id
      ) {
        commit("setPanier", {});
      }

      if (ligne.quantite <= 0) {
        Vue.$toast.error({ title: i18n.t("panier.quantite-0") });
        return;
      }
      const produit = {
        id: ligne.id,
        nom: ligne.nom,
        quantite: ligne.quantite,
        liste_id: ligne.liste_id,
      };
      getters.panier[ligne.id] = produit;

      // Sauvegarde du panier
      commit("setPanier", getters.panier);
    },

    addMultipleToPanier({ getters, dispatch }, { lignes = [] }) {
      if (lignes.length > 0) {
        for (let l in lignes) {
          // Si le prix est de 0 : pas d'ajout
          if (lignes[l].prix_ttc === 0) continue;
          dispatch("setOfferToPanier", { ligne: lignes[l] });
        }
      }
    },

    removeOfferFromPanier({ commit, getters }, { id = null }) {
      if (!id) return;
      delete getters.panier[id];
      commit("setPanier", getters.panier);
    },

    clearPanier({ commit }) {
      commit("setPanier", {});
    },
  },
};
